import { Router } from '@reach/router'
import { graphql } from 'gatsby'
import React from 'react'

import Layout from '../components/layout'
import SuburbContainer from '../components/sub-dinner/Container'

const Suburb = () => {
  return (
    <Layout>
      <Router>
        <SuburbContainer path="/suburb" />
      </Router>
    </Layout>
  )
}

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`

export default Suburb
